import React from "react"
import CustomImage from "@/main/customImage"
import { Field } from "formik"

import { Col, Form, InputGroup } from "react-bootstrap"

function EmailField(props) {
    return (
        <>
            {/* User Email Field */}
            <Col md={12}>
                <Form.Group className="form-input-group">
                    <Form.Label htmlFor="email">
                        <span className="text-semi-bold text-sm">Email</span>
                    </Form.Label>
                    <InputGroup className="input-group shadow-sm">
                        <InputGroup.Text
                            className="p-0"
                            style={{
                                width: "2.5rem",
                            }}
                        >
                            <CustomImage
                                src="https://webb-jenkins-static-164679926.imgix.net/icons/email-black.svg"
                                alt="Email icon"
                                height={16}
                                width={40}
                            />
                        </InputGroup.Text>

                        <Field
                            id="email"
                            name="email"
                            type="email"
                            className="form-control"
                        />
                    </InputGroup>
                    {props.formik.errors.email && props.formik.touched.email ? (
                        <p className="text-danger text-sm">
                            {props.formik.errors.email}
                        </p>
                    ) : null}
                </Form.Group>
            </Col>
            {/* User Email Field End */}
        </>
    )
}

export default EmailField
